<template>
   <v-card>
        <v-card-title primary-title >
            Payment Infos
        </v-card-title>
        <v-card-text>
            {{ order.cc_brand }}
            {{ order.wo_po_number }}
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from "vuex"
import formatter from '@/helpers/formatter'

export default {
    props: {
        order: {
            type: Object,
            //  required: true
        }
    },
    components: {},
    data() {
        return {
            formatter,
            tab: 'tab-settings',
            isLoading: false,
        }
    },
    computed: {
        ...mapGetters([
            // 'orders',
            // 'articleTypes'
        ])
    },
    methods: {
        close () {
            this.$emit('close')
        },

    },
    watch: {
        order: function (value) {
           
        
        }
    },
    created() {

    },
    mounted () {
        // this.isLoading = true
        // this.$store.dispatch('getOrderArticles', this.orderId)
        //         .then(articles => this.articles = articles)
        //         .then(() => this.isLoading = false)
    }
}
</script>
